const config = {
  apiGateways: {
    BASE_URL_1: `${process.env.REACT_APP_BACKEND_URL_HTTP}`
  },
  SOCKET_URL: `${process.env.REACT_APP_BACKEND_URL_WS}`
}

export default config
